import { t } from '@lingui/core/macro';
import { TextAreaField } from 'shared/domains/forms';
export function RegularInput() {
    return (<TextAreaField autosizeHeight maxHeight={250} name="content" label={t({ message: 'Content', comment: 'Prompt content field label' })} placeholder={t({
            message: 'Enter your prompt here',
            comment: 'Prompt content field placeholder',
        })}/>);
}
